var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("customs-declaration", {
    attrs: {
      job: _vm.job,
      "is-editing": _vm.isEditing,
      "del-po-items-uuids": _vm.job.delPoItemsUuids || []
    },
    on: {
      quantityActualChange: function($event) {
        return _vm.onChange("quantityActual")
      },
      weightActualChange: function($event) {
        return _vm.onChange("weightActual")
      },
      cubageActualChange: function($event) {
        return _vm.onChange("cubageActual")
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }